// extracted by mini-css-extract-plugin
export default {"pageWithLayouts":"PageWithLayouts_pageWithLayouts__k6H51","hasCustomLogos":"PageWithLayouts_hasCustomLogos__5wHOY"};